/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeLeaveBalancesSummary } from './EmployeeLeaveBalancesSummary';
import {
    EmployeeLeaveBalancesSummaryFromJSON,
    EmployeeLeaveBalancesSummaryFromJSONTyped,
    EmployeeLeaveBalancesSummaryToJSON,
    EmployeeLeaveBalancesSummaryToJSONTyped,
} from './EmployeeLeaveBalancesSummary';

/**
 * 
 * @export
 * @interface ListEmployeeLeaveBalanceSummariesResponse
 */
export interface ListEmployeeLeaveBalanceSummariesResponse {
    /**
     * 
     * @type {Array<EmployeeLeaveBalancesSummary>}
     * @memberof ListEmployeeLeaveBalanceSummariesResponse
     */
    data: Array<EmployeeLeaveBalancesSummary>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeLeaveBalanceSummariesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeLeaveBalanceSummariesResponse interface.
 */
export function instanceOfListEmployeeLeaveBalanceSummariesResponse(value: object): value is ListEmployeeLeaveBalanceSummariesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeLeaveBalanceSummariesResponseFromJSON(json: any): ListEmployeeLeaveBalanceSummariesResponse {
    return ListEmployeeLeaveBalanceSummariesResponseFromJSONTyped(json, false);
}

export function ListEmployeeLeaveBalanceSummariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeLeaveBalanceSummariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeLeaveBalancesSummaryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeLeaveBalanceSummariesResponseToJSON(json: any): ListEmployeeLeaveBalanceSummariesResponse {
      return ListEmployeeLeaveBalanceSummariesResponseToJSONTyped(json, false);
  }

  export function ListEmployeeLeaveBalanceSummariesResponseToJSONTyped(value?: ListEmployeeLeaveBalanceSummariesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeLeaveBalancesSummaryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

